// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleButton_wrapper__uQlnz","toggleButton":"ToggleButton_toggleButton__2SaJT","disabled":"ToggleButton_disabled__1NTEU"};